import { Modal, Row, Col, Button, List, Image } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import cedulaSi from "../../../assets/img/cedulasi.jpeg";
import cedulaNo from "../../../assets/img/cedulano.jpg";

const ImageInstructionsModal = ({ visible, setVisible }) => {
  const data = [
    {
      title: "Foto encuadrada",
      subtitle: "Intenta que la cédula ocupe todo el espacio",
    },
    {
      title: "Buena iluminación",
      subtitle: "Utiliza luz natural o el anillo de luz disponible",
    },
    {
      title: "Fondo oscuro",
      subtitle: "Utiliza un fondo que haga contraste con la cédula",
    },
  ];

  const handleCancel = () => setVisible(false);
  return (
    <Modal
      open={visible}
      title="Cómo subir cédulas"
      onCancel={handleCancel}
      width={1000}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          OK
        </Button>,
      ]}
    >
      <Row gutter={16}>
        <Col span={8}>
          <CheckCircleOutlined style={{ fontSize: "44px", color: "green" }} />
        </Col>
        <Col span={8}></Col>
        <Col span={8}>
          <CloseCircleOutlined style={{ fontSize: "44px", color: "red" }} />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Image src={cedulaSi} />
        </Col>
        <Col span={8}>
          <List
            itemLayout="horizontal"
            dataSource={data}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  avatar={
                    <CheckCircleOutlined
                      style={{ fontSize: "15px", color: "green" }}
                    />
                  }
                  title={<span>{item.title}</span>}
                  description={item.subtitle}
                />
              </List.Item>
            )}
          />
        </Col>
        <Col span={8}>
          <Image src={cedulaNo} />
        </Col>
      </Row>
    </Modal>
  );
};

export default ImageInstructionsModal;
